import useAccessibleSubmit from "@insite/client-framework/Common/Hooks/useAccessibleSubmit";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import updateWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLine";
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import addCustomerProductNumber from "@waytek/Store/Components/CustomerNumberComponent/Handlers/AddCustomerProductNumber";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    productId?: string | null;
    customerNumber: string;
    extendedStyles?: CustomerNumberComponentStyles;
    shouldUpdate?: boolean;
    onCustomerNumberChange?: (newCustomerNumber: string) => void;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    cartLoadedTime: state.data.carts.cartLoadedTime,
});

const mapDispatchToProps = {
    updateCartLine,
    updateWishListLine,
    addCustomerProductNumber,
};

export type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CustomerNumberComponentStyles {
    customerLabel?: TypographyProps;
    customerInput?: TextFieldPresentationProps;
}

export const customerNumberComponentStyles: CustomerNumberComponentStyles = {};

const CustomerNumberComponent = ({
    productId,
    customerNumber,
    extendedStyles,
    cartLoadedTime,
    addCustomerProductNumber,
    onCustomerNumberChange = () => {},
}: Props) => {
    const [styles] = React.useState(() => mergeToNew(customerNumberComponentStyles, extendedStyles));

    const localOnFirstNameChange = (inputValue: string) => {
        if (productId) {
            addCustomerProductNumber({
                productId,
                customerPartNumber: inputValue.trim(),
            });
            onCustomerNumberChange(inputValue.trim());
        }
    };

    const { value, changeHandler, keyDownHandler, blurHandler } = useAccessibleSubmit(
        customerNumber,
        localOnFirstNameChange,
        cartLoadedTime,
    );

    return (
        <>
            <Typography {...styles.customerLabel}>{translate("Customer #:")}</Typography>
            <TextField
                {...styles.customerInput}
                value={value}
                onChange={changeHandler}
                onKeyDown={keyDownHandler}
                onBlur={blurHandler}
                maxLength={22}
            />
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerNumberComponent);
